<template>
  <div>
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title class="breadcrumbs d-flex align-center">
        <v-icon class="text-primary">{{ icons.arrowLeft }}</v-icon>
        <router-link class="text-decoration--none" :to="{ name: 'places' }"
          >Places</router-link
        >
      </v-toolbar-title>
    </v-app-bar>

    <div class="ma-4" v-if="form">
      <div class="display-2 font-weight-bold my-6 text-capitalize">
        Update Place
      </div>

      <!-- Place Form -->
      <div class="col-md-4 col-sm-12 col-xs-12 mt-6 pa-0">
        <v-form ref="form" v-if="form" class="place-form">
          <h3 class="py-5 primary--text">Place Information</h3>

          <label class="text-field-label">Name</label>
          <v-text-field
            flat
            solo
            required
            class="mt-2"
            v-model="form.name"
            :error-messages="form.$getError('name')"
            :loading="loading"
          ></v-text-field>

          <label class="text-field-label">Type</label>
          <v-select
            class="mt-2"
            v-model="form.type"
            :items="placeTypes"
            filled
          ></v-select>

          <label class="text-field-label">Location</label>
          <PlaceAutocomplete
            all
            v-model="form.places_address"
            @select="form.google_places_id = $event"
            :inputError="form.$getError('places_address')"
          />

          <label class="text-field-label">Image</label>
          <v-file-input
            class="mb-2"
            accept="image/*"
            v-model="form.image"
          ></v-file-input>

          <label class="text-field-label">Description</label>
          <v-textarea
            class="mt-2"
            v-model="form.description"
            filled
            auto-grow
            :error-messages="form.$getError('description')"
          ></v-textarea>

          <div class="mt-5 d-flex">
            <v-btn
              color="normal"
              class="mr-5 px-6"
              height="40px"
              width="47%"
              :loading="form.$busy"
              :to="{ name: 'places' }"
              >Back</v-btn
            >

            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              class="px-6"
              height="40px"
              width="47%"
              :loading="form.$busy"
              @click="updatePlaceDetails"
              >Save</v-btn
            >
          </div>
        </v-form>
      </div>
      <!-- End of Place Form -->
    </div>

    <v-snackbar v-model="snackbar.show" right :color="snackbar.color">
      {{ snackbar.message }}
      <v-btn text @click="snackbar.show = false">OK</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import ControlsMixin from '@/utils/mixins/Controls'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import PlaceAutocomplete from '@/components/PlaceAutocomplete'
import { mdiChevronLeft } from '@mdi/js'

import Form from '@/utils/form'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'UpdatePlace',

  mixins: [ControlsMixin],

  components: {
    AppBarNavIcon,
    PlaceAutocomplete
  },

  data() {
    return {
      icons: {
        arrowLeft: mdiChevronLeft
      },
      form: true,
      loading: false,
      placeTypes: ['Store', 'Restaurant', 'Landmark'],
      snackbar: {
        show: false,
        message: null,
        color: ''
      }
    }
  },

  computed: {
    ...mapState({
      place: state => state.place.placeDetails
    })
  },

  created() {
    this.form = new Form(this.place)
    this.getPlace()
  },

  destroyed() {
    this.clearPlaceDetails()
  },

  methods: {
    ...mapActions({
      updatePlace: 'place/updatePlace',
      clearPlaceDetails: 'place/clearPlaceDetails',
      getPlaceDetails: 'place/getPlaceDetails',
      setAlert: 'alert/setAlert'
    }),

    async getPlace() {
      this.loading = true
      await this.getPlaceDetails(this.$route.params.id)
      this.form.google_places_id = null
      this.form = new Form(this.place)
      this.form.type =
        this.form.type.charAt(0).toUpperCase() + this.form.type.slice(1)
      this.loading = false
    },

    async updatePlaceDetails() {
      this.form.$busy = true
      this.form.$clearErrors()

      let data = new FormData()
      data.append('_method', 'PUT')
      data.append('id', this.form.$data().id)
      data.append('type', this.form.$data().type.toLowerCase())

      // Check if name is null
      if (this.form.name !== null) {
        data.append('name', this.form.$data().name)
      }

      // Check if description is null
      if (this.form.description !== null) {
        data.append('description', this.form.$data().description)
      }

      // Check if image is valid file
      if (this.form.image instanceof File) {
        data.append('image', this.form.image)
      }

      // Check if image file is removed
      if (this.form.image == null) {
        data.append('image', '')
      }

      // Check if location is null
      if (this.form.places_address !== null) {
        data.append('places_address', this.form.$data().places_address)
      }

      // Check if google place id is provided
      if (this.form.google_places_id == null) {
        data.append('google_places_id', '')
      } else {
        data.append('google_places_id', this.form.google_places_id)
      }

      this.updatePlace(data)
        .then(() => {
          this.form.$busy = false
          this.setAlert({
            message: 'Place details successfully updated!',
            color: 'success'
          })
          this.$router.replace({ name: 'places.listing' })
        })
        .catch(err => {
          this.form.$busy = false
          if (err.response.status === 422) {
            this.form.$setErrors(err.response.data.errors)
          }
        })
    },

    showSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    }
  }
}
</script>
